// src/context/CartContext.js
import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartContext = createContext(null);

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD': {
      const key = `${action.item.id}__${action.item.selectedSize || ''}__${action.item.selectedColor || ''}`;
      const existing = state.find(i => i._key === key);
      if (existing) return state.map(i => i._key === key ? { ...i, qty: i.qty + 1 } : i);
      return [...state, { ...action.item, qty: 1, _key: key }];
    }
    case 'REMOVE':
      return state.filter(i => i._key !== action.key);
    case 'UPDATE_QTY':
      return state.map(i => i._key === action.key ? { ...i, qty: Math.max(1, action.qty) } : i);
    case 'CLEAR':
      return [];
    default:
      return state;
  }
}

export const CartProvider = ({ children }) => {
  const saved = (() => {
    try { return JSON.parse(localStorage.getItem('sw_cart') || '[]'); }
    catch { return []; }
  })();

  const [cart, dispatch] = useReducer(cartReducer, saved);

  useEffect(() => {
    localStorage.setItem('sw_cart', JSON.stringify(cart));
  }, [cart]);

  const totalItems = cart.reduce((a, i) => a + i.qty, 0);
  const subtotal = cart.reduce((a, i) => a + i.price * i.qty, 0);

  const addToCart = (item) => dispatch({ type: 'ADD', item });
  const removeFromCart = (key) => dispatch({ type: 'REMOVE', key });
  const updateQty = (key, qty) => dispatch({ type: 'UPDATE_QTY', key, qty });
  const clearCart = () => dispatch({ type: 'CLEAR' });

  return (
    <CartContext.Provider value={{ cart, totalItems, subtotal, addToCart, removeFromCart, updateQty, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
